import createGlobalState from "@ui/lib/createGlobalState";
import { SymptomChartType } from "../SymptomChartType";

export const useSymptomChartType = createGlobalState({
  storage: "session",
  key: "symptomChartType",
  type: SymptomChartType,
  scoped: true,
});
